<template>
    <button
        class="sb-banner-button"
        :disabled="disabled"
    >
        <h1 class="">
            <div>{{ $t('EM_DASH') }}<slot />{{ $t('EM_DASH') }}</div>
        </h1>
    </button>
</template>

<style lang="scss" scoped>
    @import "../style/variables.scss";
    @import "../style/shared.scss";

    .sb-banner-button {
        font-family: 'BluuNext-Bold', sans-serif;
        font-size: 24px !important;
        color: #112344;

        padding: 16px 0 10px !important;

        @include respond-above-height(lg, short) {
            font-size: 30px !important;
            padding: 22px 0 !important;
        }

        @include respond-above-height(lg, medium) {
            font-size: 50px !important;
            padding: 22px 0 !important;
        }

        white-space: nowrap;
    }
</style>

<script>
    export default {
        props: {
            as: String,
            disabled: Boolean,
        },

        computed: {
            headerFontClass() {
                return this.$store.getters.headerFontClass;
            },
        },
    };
</script>
